import { BillingitemReplaceRequestV26 } from 'src/app/models-v26/billingitem-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { ServiceAlias } from 'src/app/models/service';
import { ReplaceBillingitemsDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-billingitems-wizard/activation-step/replacebillingitems-due-date-info';
import { ReplaceBillingitemsInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-billingitems-wizard/init-step/init-step';

export interface State {
  initStep: ReplaceBillingitemsInitStepV26;
  dueDatesStep: ReplaceBillingitemsDueDatesV26;
  serviceStep: ServiceAlias[];
  request: BillingitemReplaceRequestV26;
  response: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  initStep: null,
  dueDatesStep: { activationDate: null },
  serviceStep: null,
  request: null,
  response: null,
  errorMessage: null,
};
